import React, { createContext, useContext, useEffect, useState } from 'react';
const InformationMessageStateContext = createContext(null);
InformationMessageStateContext.displayName = 'InformationMessageContext';
const InformationMessageStateProvider = ({ children, collapsedDefault, ...rest }) => {
    const [isCollapsed, setIsCollapsed] = useState(!!collapsedDefault);
    function toggleCollapse() {
        setIsCollapsed(open => {
            const newValue = !open;
            rest.onToggleChanged?.(newValue);
            return newValue;
        });
    }
    useEffect(() => {
        if (rest.isCollapsed !== undefined)
            setIsCollapsed(rest.isCollapsed);
    }, [rest.isCollapsed]);
    const contextValue = {
        toggleCollapse,
        isCollapsed,
        setIsCollapsed,
        collapsedDefault,
        ...rest,
    };
    return (<InformationMessageStateContext.Provider value={contextValue}>
      {children}
    </InformationMessageStateContext.Provider>);
};
InformationMessageStateProvider.displayName = 'InformationMessage State Provider';
export const useInformationMessageState = () => {
    const context = useContext(InformationMessageStateContext);
    if (!context) {
        // eslint-disable-next-line max-len
        throw new Error('useInformationMessageState must be used within the InformationMessage State Provider');
    }
    return context;
};
export default InformationMessageStateProvider;
//# sourceMappingURL=InformationMessageStateProvider.js.map